import { motion } from "framer-motion";
import Images from "../../utils/Images";

const ProductMarketplaceBanner = () => {
  return (
    <section className="overflow-hidden relative py-16 bg-gradient-to-r from-orange-50 to-pink-50 via-peach-50">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div
          className="absolute top-0 left-0 w-full h-full opacity-20"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23f97316' fill-opacity='0.1'%3E%3Cpath d='M20 20c0-11.046-8.954-20-20-20v20h20z'/%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      <div className="relative z-10 px-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
        <div className="flex flex-col gap-12 justify-between items-center lg:flex-row">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="flex-1 text-left"
          >
            <h2 className="mb-4 text-4xl font-bold text-gray-800 lg:text-5xl">
              Premium Products at Unbeatable Prices
            </h2>
            <p className="mb-4 text-lg text-gray-600">
              Discover exclusive deals on top brands and quality electronics
            </p>
            <p className="text-base text-gray-500">
              From smartphones to smart home devices - find everything you need at amazing prices
            </p>
          </motion.div>

          {/* Right Content - Products */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative flex-1"
          >
            <div className="flex relative gap-8 justify-center items-center">
              {/* Single Phone with Price Tag */}
              <motion.div
                initial={{ opacity: 0, rotate: -10 }}
                animate={{ opacity: 1, rotate: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="relative z-10"
              >
                <img
                  src={Images.phones}
                  alt="Xiaomi Phone"
                  className="object-cover w-64 h-90"
                />
                {/* Xiaomi Brand */}
                <div className="absolute -bottom-2 left-1/2 px-2 py-1 text-xs text-white bg-gray-800 rounded transform -translate-x-1/2">
                  xiaomi
                </div>
              </motion.div>

              {/* Beatbox Speaker with Price Tag - Much Bigger */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                className="relative z-20"
              >
                <img
                  src={Images.beatbox}
                  alt="Apple HomePod Mini"
                  className="object-contain w-64 h-64"
                />
              </motion.div>

              {/* Floating Elements */}
              <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 1.4 }}
                className="absolute -top-4 -right-4 w-8 h-8 bg-yellow-400 rounded-full opacity-60"
              />
              <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 1.6 }}
                className="absolute -bottom-4 -left-4 w-6 h-6 bg-pink-400 rounded-full opacity-60"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProductMarketplaceBanner;
